import React, { useState, useEffect, useRef } from "react";
import SideBar from "../SideBar/sideBar";
import { useNavigate, useLocation } from "react-router-dom";
import '../../index.css';
import { chatBot, ChatList } from "../api/Service";
import Modal from 'react-modal';
import AssistantIcon from '@mui/icons-material/Assistant';

const CreditCoach = () => {
    const navigate = useNavigate();
    const location = useLocation();
    // const { openModal } = location.state || {};
    const FirstName = localStorage.getItem('firstName') || '';
    const LastName = localStorage.getItem('lastName') || '';
    const initials = `${FirstName.charAt(0)}${LastName.charAt(0)}`;
    const PlanTypeName = localStorage.getItem('PlanTypeName');
    const [customMessage, setCustomMessage] = useState('');
    const [messages, setMessages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [disable, setDisable] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [typedMessage, setTypedMessage] = useState('');
    // const [modal, setModal] = useState(openModal)
    // console.log(openModal,'hiiiiiiiii')
    const handleMessageClick = (message) => {
        const newMessage = { role: 'user', content: message };
        const updatedMessages = [...messages, newMessage];
        setMessages(updatedMessages);
        handleApi(message);
    };

    const handleCustomChange = (e) => {
        setCustomMessage(e.target.value);
    };

    const handleApi = async (message) => {
        if (!message) {
            return false;
        }
        setDisable(true);
        const newMessage = { role: 'user', content: message };
        const updatedMessages = [...messages, newMessage];

        setMessages(updatedMessages);
        setCustomMessage('');
        setTypedMessage('');

        if (PlanTypeName === 'Free' && messages.length === 6) {
            setIsModalOpen(true);
        } else {
            try {
                let data = { content: message };

                const response = await chatBot(data);
                if (!response) {
                    setDisable(true);
                } else {
                    setDisable(false);
                }
                const assistantMessage = { role: 'assistant', content: response.data };
                
                setMessages([...updatedMessages, assistantMessage]);
                displayWordByWord(response.data);
            } catch (err) {
                console.log(err);
            }
        }
    };

    const displayWordByWord = (message) => {
        let words = message.split(' ');
        let i = 0;
        setTypedMessage('');

        const interval = setInterval(() => {
            if (i < words.length) {
                setTypedMessage((prev) => (prev ? prev + ' ' + (words[i] ? words[i] : '') : (words[i] ? words[i] : '')));
                i++;
            } else {
                clearInterval(interval);
            }
        }, 100);
    };

    const messagesEndRef = useRef(null);
    const scrollToBottom = () => {
        if (messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    useEffect(() => {
        scrollToBottom();
    }, [messages, typedMessage]);

    const DisplayList = async () => {
        const response = await ChatList(),
            data = response.data;
        setMessages(data);
    };

    useEffect(() => {
        if (loading) {
            DisplayList();
            setLoading(false);
        }
    }, [loading]);

    function formatTextWithLineBreaks(text) {
        return text.replace(/\n/g, '<br />');
    }

    return (
        // <div className="flex h-screen bg-[#121212]">
        //     {modal ? (<><div className="absolute inset-0 bg-opacity-100"></div></>) : (<SideBar />)}

        //     <main className="flex-1 p-6 h-screen flex flex-col">
        //         <div className="flex justify-between items-center mt-5 mb-8">
        //             <h1 className="text-3xl font-bold text-white">AI Credit Coach</h1>
        //             <div className="ml-[30.75rem]">
        //             {PlanTypeName?.includes('Lifetime Access')&&<h1 className="text-white font-semibold">You Have Lifetime Access</h1>}
        //             </div>
        //             <div className="w-10 h-10 bg-purple-500 rounded-full flex items-center justify-center">
        //                 <span className="text-white font-bold">{initials}</span>
        //             </div>
        //         </div>

        //         <div className="flex flex-col flex-1 h-[88%] bg-[#1a1a1a] text-white">
        //             <div className="flex flex-col p-6 max-w-4xl mx-auto">
        //                 <div className="block md:hidden mb-2">
        //                     <select
        //                         className="w-full p-3 bg-[#1f1f1f] text-white rounded-lg cursor-pointer transition transform hover:bg-[#444] focus:outline-none"
        //                         onChange={(e) => handleMessageClick(e.target.value)}
        //                         defaultValue=""
        //                     >
        //                         <option value="" disabled>
        //                             Select a question
        //                         </option>
        //                         {[
        //                             'How can I improve my credit score?',
        //                             'What factors affect my credit score?',
        //                             'How to dispute errors on my credit report?',
        //                             'Best ways to build credit from scratch?'
        //                         ].map((question, index) => (
        //                             <option key={index} value={question}>
        //                                 {question}
        //                             </option>
        //                         ))}
        //                     </select>
        //                 </div>

        //                 <div className="hidden md:grid grid-cols-1 md:grid-cols-2 gap-6 mb-2">
        //                     {[
        //                         'How can I improve my credit score?',
        //                         'What factors affect my credit score?',
        //                         'How to dispute errors on my credit report?',
        //                         'Best ways to build credit from scratch?'
        //                     ].map((question, index) => (
        //                         <div
        //                             key={index}
        //                             className="bg-[#1f1f1f] p-2 rounded-lg shadow-lg text-center cursor-pointer transition transform hover:bg-[#444] hover:scale-105"
        //                         ><div onClick={() => handleMessageClick(question)} className="text-xl">
        //                                 {question}
        //                             </div>

        //                         </div>
        //                     ))}
        //                 </div>
        //             </div>

        //             <div className="flex-1 overflow-y-auto pr-2">
        //                 {messages.map((msg, index) => (
        //                     <div key={index} className="space-y-4">

        //                         {msg.role === 'assistant' ? (
        //                             <div className="flex justify-start p-5">
        //                                 <div
        //                                     className="bg-[#444] max-w-[1040px] w-[100%] text-white p-3 rounded-lg"
        //                                     dangerouslySetInnerHTML={{

        //                                         __html: formatTextWithLineBreaks(
        //                                             index === messages.length - 1 && typedMessage ? (typedMessage) : (msg.content)
        //                                         ),
        //                                     }}
        //                                 />
        //                             </div>
        //                         ) : (
        //                             <div className="flex justify-end p-5">
        //                                 <div
        //                                     className="bg-[#444] text-white p-3 rounded-lg max-[1040px]"
        //                                     dangerouslySetInnerHTML={{
        //                                         __html: formatTextWithLineBreaks(msg.content),
        //                                     }}
        //                                 />
        //                             </div>
        //                         )}
        //                     </div>
        //                 ))}
        //                 {disable ? (
        //                     <p className="text-gray-200 p-2 mr-2 animate-pulse">
        //                         Generating... <AssistantIcon className="mr-2" />
        //                     </p>
        //                 ) : null}
        //                 <div ref={messagesEndRef} />
        //             </div>
        //             <div className="p-4 w-[90%] bg-[#1a1a1a] border-t border-[#333]">
        //                 <div className="flex items-center space-x-3">
        //                     <input
        //                         className="flex-1 bg-[#333] border-none rounded-lg px-4 py-3 text-white placeholder-[#888] focus:outline-none focus:ring focus:ring-blue-500"
        //                         placeholder="Ask about credit repair..."
        //                         type="text"
        //                         value={customMessage}
        //                         onChange={handleCustomChange}
        //                     />

        //                     <button
        //                         onClick={() => handleApi(customMessage)}
        //                         className={` bg-blue-600 text-white rounded-lg px-5 py-3 shadow-lg transform hover:scale-105 focus:ring focus:ring-blue-500 transition ${disable ? 'opacity-50 cursor-not-allowed' : ''}`}
        //                         disabled={disable}
        //                     >
        //                         <i className="fa fa-paper-plane"></i>
        //                     </button>
        //                 </div>
        //                 <div className="text-[#888] mt-4 text-center text-sm">
        //                     Our AI Credit Coach is here to help. For personalized advice, consult a financial professional.
        //                 </div>
        //             </div>
        //             <Modal
        //                 isOpen={modal}
        //                 className="fixed inset-0 flex items-center justify-center z-50"
        //                 overlayClassName="fixed inset-0 bg-black bg-opacity-50 z-40"
        //             >
        //                 <div className="flex flex-col items-center bg-gradient-to-r from-purple-500 to-blue-500 p-4 sm:p-6 rounded-lg w-full sm:max-w-[70%] h-auto sm:h-[75%] mx-auto relative z-10"
        //                  Style={{
        //                     '@media(min-width: 2560px)': {
        //                       height: '53%',
        //                     },
        //                   }}>

        //                     {/* Cross button */}
        //                     <button
        //                         onClick={() => setModal(false)}
        //                         className="absolute top-4 right-4 text-white text-xl font-semibold p-1 rounded-full focus:outline-none hover:bg-gray-300 transition-all"
        //                     >
        //                         &#x2715; {/* This is the 'X' character */}
        //                     </button>

        //                     {/* Heading */}
        //                     <div className="w-full">
        //                         <h1 className="text-white text-xl sm:text-2xl font-semibold text-center animate-pulse">
        //                             Welcome To AI Credit Repair
        //                         </h1>
        //                         <div className="flex justify-center sm:justify-start">
        //                             <hr className="border-t-0.5 border-gray-300 w-full sm:w-[100%] mt-4" />
        //                         </div>
        //                     </div>

        //                     {/* Video container */}
        //                     <div className="w-full h-56 sm:h-80 md:h-96 lg:h-[100%] relative mb-4 sm:mb-6 rounded-lg overflow-hidden">
        //                         <iframe
        //                             src="https://player.vimeo.com/video/1019617787"
        //                             className="absolute top-0 left-0 w-full h-full rounded-xl"
        //                             frameBorder="1"
        //                             allow="autoplay; fullscreen; picture-in-picture"
        //                             allowFullScreen
        //                             title="AI Credit Repair"
        //                         ></iframe>
        //                     </div>

        //                     {/* Buttons */}
        //                     <div className="flex flex-row sm:flex-row justify-center w-[92%] sm:w-full gap-5 sm:gap-0">
        //                         <button
        //                             onClick={() => setModal(false)}
        //                             className="bg-black text-white py-3 sm:py-4 px-6 rounded-2xl text-sm sm:rounded-3xl sm:mr-8 hover:bg-gray-700 scale-105 transition-all duration-300 ease-in-out transform hover:scale-110 cursor-pointer">
        //                             EXPLORE DASHBOARD
        //                         </button>
        //                         <button
        //                             onClick={() => {
        //                                 navigate('/app/subscription');
        //                                 setModal(false);
        //                             }}
        //                             className="bg-black text-white py-3 sm:py-4 px-6 rounded-2xl text-sm sm:rounded-3xl hover:bg-gray-700 scale-105 transition-all duration-300 ease-in-out transform hover:scale-110 cursor-pointer">
        //                             GRAB A PLAN
        //                         </button>
        //                     </div>
        //                 </div>


        //             </Modal>


        //             <Modal
        //                 isOpen={isModalOpen}
        //                 className="fixed inset-0 flex items-center justify-center z-50"
        //                 overlayClassName="fixed inset-0 bg-black bg-opacity-50 z-40"
        //             >
        //                 <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
        //                     <h2 className="text-2xl font-semibold text-center mb-4">Alert !! </h2>
        //                     <p className="text-center mb-6">Upgrade your plan to send more messages.</p>
        //                     <div className="flex justify-center">
        //                         <button
        //                             onClick={() => { setIsModalOpen(false) }}
        //                             className="bg-red-500 hover:bg-red-600 text-white font-bold py-2 px-4 rounded mr-5"
        //                         >
        //                             Cancel
        //                         </button>
        //                         <button
        //                             onClick={() => { navigate('/app/subscription') }}
        //                             className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded "
        //                         >
        //                             OK
        //                         </button>
        //                     </div>
        //                 </div>
        //             </Modal>
        //         </div>
        //     </main>
        // </div>
        <div className="flex flex-col md:flex-row h-screen bg-[#121212]">
            
                <SideBar />
            

            <main className="flex-1 md:p-6 h-full flex flex-col w-[100%] sm:w-[100%]">
                <div className="flex flex-col md:flex-row justify-between items-center mt-5 mb-4">
                    <h1 className="text-2xl md:text-3xl font-bold text-white">AI Credit Coach</h1>
                    <div className="ml-0 md:ml-[30.75rem] mt-4 md:mt-0">
                        {PlanTypeName?.includes('Lifetime Access') && (
                            <h1 className="text-white font-semibold">You Have Lifetime Access</h1>
                        )}
                    </div>
                    <div className="w-10 h-10 bg-purple-500 rounded-full flex items-center justify-center mt-4 md:mt-0">
                        <span className="text-white font-bold">{initials}</span>
                    </div>
                </div>

                <div className="flex flex-col flex-1 bg-[#1a1a1a] h-[83%] sm:h-[91%] text-white">
                    <div className="flex flex-col p-6 max-w-full md:max-w-4xl mx-auto">
                        <div className="block md:hidden mb-2">
                            <select
                                className="w-full p-3 bg-[#1f1f1f] text-white rounded-lg cursor-pointer"
                                onChange={(e) => handleMessageClick(e.target.value)}
                                defaultValue=""
                            >
                                <option value="" disabled>
                                    Select a question
                                </option>
                                {[
                                    'How can I improve my credit score?',
                                    'What factors affect my credit score?',
                                    'How to dispute errors on my credit report?',
                                    'Best ways to build credit from scratch?',
                                ].map((question, index) => (
                                    <option key={index} value={question}>
                                        {question}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="hidden md:grid grid-cols-1 md:grid-cols-2 gap-6 mb-2">
                            {[
                                'How can I improve my credit score?',
                                'What factors affect my credit score?',
                                'How to dispute errors on my credit report?',
                                'Best ways to build credit from scratch?',
                            ].map((question, index) => (
                                <div
                                    key={index}
                                    className="bg-[#1f1f1f] p-2 rounded-lg shadow-lg text-center cursor-pointer transition transform hover:bg-[#444] hover:scale-105"
                                    onClick={() => handleMessageClick(question)}
                                >
                                    <div className="text-xl">{question}</div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="flex-1 overflow-y-auto pr-2 ">
                        {messages.map((msg, index) => (
                            <div key={index} className="space-y-4">
                                {msg.role === 'assistant' ? (
                                    <div className="flex justify-start p-5">
                                        <div
                                            className="bg-[#444] max-w-[1040px] w-full text-white p-3 rounded-lg"
                                            dangerouslySetInnerHTML={{
                                                __html: formatTextWithLineBreaks(
                                                    index === messages.length - 1 && typedMessage ? typedMessage : msg.content
                                                ),
                                            }}
                                        />
                                    </div>
                                ) : (
                                    <div className="flex justify-end p-5">
                                        <div
                                            className="bg-[#444] text-white p-3 rounded-lg max-w-[1040px]"
                                            dangerouslySetInnerHTML={{
                                                __html: formatTextWithLineBreaks(msg.content),
                                            }}
                                        />
                                    </div>
                                )}
                            </div>
                        ))}
                        {disable && (
                            <p className="text-gray-200 p-2 mr-2 animate-pulse">
                                Generating... <AssistantIcon className="mr-2" />
                            </p>
                        )}
                        <div ref={messagesEndRef} />
                    </div>

                    <div className="p-4 sm:w-[95%] w-[86%] bg-[#1a1a1a] border-t border-[#333]">
                        <div className="flex items-center space-x-3">
                            
                            <input
                                className="flex-1 bg-[#333] border-none rounded-lg px-4 py-3 text-white placeholder-[#888] focus:outline-none focus:ring focus:ring-blue-500"
                                placeholder="Ask about credit repair..."
                                type="text"
                                value={customMessage}
                                onChange={handleCustomChange}
                            />
                            <button
                                onClick={() => handleApi(customMessage)}
                                className={`bg-blue-600 text-white rounded-lg cursor-pointer px-5 py-3 shadow-lg transform hover:scale-105 focus:ring focus:ring-blue-500 transition ${disable ? 'opacity-50 cursor-not-allowed' : ''
                                    }`}
                                disabled={disable}
                            >
                                <i className="fa fa-paper-plane"></i>
                            </button>
                        </div>
                        <div className="text-[#888] mt-4 text-center text-sm">
                            Our AI Credit Coach is here to help. For personalized advice, consult a financial professional.
                        </div>
                    </div>

                    {/* <Modal
                        isOpen={modal}
                        className="fixed inset-0 flex items-center justify-center z-50"
                        overlayClassName="fixed inset-0 bg-black bg-opacity-50 z-40"
                    >
                        <div className="flex flex-col items-center bg-gradient-to-r from-purple-500 to-blue-500 p-4 sm:p-6 rounded-lg w-full sm:max-w-[90%] h-auto sm:h-[75%] mx-auto relative z-10">
                            <button
                                onClick={() => setModal(false)}
                                className="absolute top-4 right-4 text-white text-xl font-semibold p-1 rounded-full focus:outline-none hover:bg-gray-300 transition-all"
                            >
                                &#x2715;
                            </button>

                            <div className="w-full">
                                <h1 className="text-white text-xl sm:text-2xl font-semibold text-center animate-pulse">
                                    Welcome To AI Credit Repair
                                </h1>
                                <div className="flex justify-center sm:justify-start">
                                    <hr className="border-t-0.5 border-gray-300 w-full sm:w-full mt-4" />
                                </div>
                            </div>

                            <div className="w-full h-56 sm:h-80 md:h-96 lg:h-[100%] relative mb-4 sm:mb-6 rounded-lg overflow-hidden">
                                <iframe
                                    src="https://player.vimeo.com/video/1019617787"
                                    className="absolute top-0 left-0 w-full h-full rounded-xl"
                                    frameBorder="0"
                                    allow="autoplay; fullscreen; picture-in-picture"
                                    allowFullScreen
                                    title="AI Credit Repair"
                                ></iframe>
                            </div>

                            <div className="flex flex-col sm:flex-row justify-center w-full gap-5">
                                <button
                                    onClick={() => setModal(false)}
                                    className="bg-black text-white py-3 sm:py-4 px-6 rounded-2xl text-sm sm:rounded-3xl hover:bg-gray-700 scale-105 transition-all ease-in-out transform hover:scale-110 cursor-pointer"
                                >
                                    EXPLORE DASHBOARD
                                </button>
                                <button
                                    onClick={() => {
                                        navigate('/app/subscription');
                                        setModal(false);
                                    }}
                                    className="bg-black text-white py-3 sm:py-4 px-6 rounded-2xl text-sm sm:rounded-3xl hover:bg-gray-700 scale-105 transition-all ease-in-out transform hover:scale-110 cursor-pointer"
                                >
                                    GRAB A PLAN
                                </button>
                            </div>
                        </div>
                    </Modal> */}

                    <Modal
                        isOpen={isModalOpen}
                        className="fixed inset-0 flex items-center justify-center z-50"
                        overlayClassName="fixed inset-0 bg-black bg-opacity-50 z-40"
                    >
                        <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
                            <h2 className="text-2xl font-semibold text-center mb-4">Alert !!</h2>
                            <p className="text-center mb-6">Upgrade your plan to send more messages.</p>
                            <div className="flex justify-center">
                                <button
                                    onClick={() => setIsModalOpen(false)}
                                    className="bg-red-500 hover:bg-red-600 text-white font-bold py-2 px-4 rounded mr-5"
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={() => navigate('/app/subscription')}
                                    className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded"
                                >
                                    OK
                                </button>
                            </div>
                        </div>
                    </Modal>
                </div>
            </main>
        </div>

    );
};

export default CreditCoach;